import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {
    AnyImageOpContext,
    AnyImageOpResultNode,
    ImageOpNode,
    ImageOpOutputs,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/find-correlation-peak/definition"
import {ImageOpNodeReduce} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/reduce/node"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeTilingFindCorrelationPeak"}

@registerImageOpNode
export class ImageOpNodeTilingFindCorrelationPeak extends ImageOpNode<typeof definition> {
    override get definition() {
        return nodeDefinition
    }

    override dispose(): void {
        this.imageOpNodeBag.dispose()
        super.dispose()
    }

    override run = async (evaluator: Evaluator<AnyImageOpContext>): Promise<ImageOpOutputs<typeof definition>> => {
        const {imageOpHalOptions, correlation} = await evaluator.getAll(this.parameters)

        this.imageOpNodeBag.beginFrame()

        const resultNode: AnyImageOpResultNode = this.imageOpNodeBag.getNode("ReduceToPeak", ImageOpNodeReduce, {
            imageOpHalOptions,
            sourceImage: correlation,
            operator: "custom",
            custom: {
                preProcess: {
                    code: `
                        vec4 preProcess(vec4 value, ivec2 index) {
                            return vec4(value.r, float(index.x), float(index.y), 0);
                        }
                    `,
                    resultChannels: 3,
                },
                reduce: {
                    code: `
                        vec4 reduce(vec4 a, vec4 b) {
                            return a.r > b.r ? a : b;
                        }
                    `,
                    resultChannels: 3,
                },
            },
        })

        const result = evaluator.get(resultNode)

        this.imageOpNodeBag.endFrame()

        return result
    }

    private imageOpNodeBag = new ImageOpNodeBag("ImageOpNodeTilingFindCorrelationPeak")
}
